import api from "Common/Client/Interceptor";

const BASE_URL = "/indv/ExpertServicePurchase/expert/get-list";

export const getExpertPurchases = async (token, params = {}) => {
  try {
    const response = await api.get(BASE_URL, {
      params: {
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "*/*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("API Error in getExpertPurchases:", error);
    throw error;
  }
};